import {
  __objRest,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/components/radio-group/radio.tsx
import React from "react";
var RadioClassNames = {
  base: "text-[theme(backgroundColor.interactive-accent-surface-active)] form-radio m-[2px] h-5 w-5 cursor-pointer align-middle focus:ring-0 focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline focus-visible:outline-focus disabled:text-[theme(backgroundColor.interactive-surface-disabled)] disabled:cursor-not-allowed"
};
var Radio = (_a) => {
  var _b = _a, {
    children,
    className,
    labelPlacement = "right"
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "labelPlacement"
  ]);
  return /* @__PURE__ */ React.createElement("label", { className }, labelPlacement === "left" && children, /* @__PURE__ */ React.createElement("input", __spreadValues({ type: "radio", className: RadioClassNames.base }, props)), labelPlacement === "right" && children);
};

export {
  RadioClassNames,
  Radio
};
